<template>
  <div>
    <textarea
      rows="25"
      style="width: 100%"
      :value="value"
      @input="emitInput"
    ></textarea>
  </div>
</template>

<script>
export default {
  name: 'JsonEditorDummy',
  props: ['value'],
  methods: {
    emitInput(e) {
      this.$emit('inputText', e.target.value)
    }
  }
}
</script>
